import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';
import {HttpClient} from '@angular/common/http';
import {GnMessageService} from '../message-service/message-service';
import {GnObjectUtils} from 'geminis-ng-core';

@Component({
  selector: 'gn-select',
  template: `
    <nz-select [(ngModel)]="value" [nzAllowClear]="allowClear" [nzPlaceHolder]="placeHolder"
               (ngModelChange)="valueChanged.emit()" [nzShowSearch]="showSearch" [nzLoading]="loading"
               (nzOnSearch)="searchData($event)" (nzScrollToBottom)="appendData()" [nzDropdownRender]="renderTemplate">
      <nz-option *ngFor="let item of items" [nzValue]="item.value" [nzLabel]="item.label"></nz-option>
    </nz-select>
    <ng-template #renderTemplate>
      <nz-spin *ngIf="loading"></nz-spin>
    </ng-template>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnSelectComponent),
    multi: true
  }]
})
@GnFormItem('select')
export class GnSelectComponent implements ControlValueAccessor {

  private innerValue: any;
  private pageIndex: number;
  private searchValue: string;
  private noMore: boolean;

  loading: boolean;

  @Input() set value(v: any) {
    if (this.innerValue !== v) {
      this.innerValue = v;
      this.valueChange(this.innerValue);
    }
  }

  get value(): any {
    return this.innerValue;
  }

  @Input() items: { value: any, label: string }[] = [];

  @Input() placeHolder: string;
  @Input() allowClear: boolean;
  @Input() showSearch: boolean;
  @Input() url: string;
  @Input() pageSize = 10;
  @Input() includes: string[];
  @Input() searchField: string;
  @Input() valueField: string;
  @Input() labelField: string;
  @Output() valueChanged = new EventEmitter();

  constructor(private http: HttpClient,
              private messageService: GnMessageService) {
  }

  searchData(value: string): void {
    if (this.showSearch) {
      this.searchValue = value;
      this.pageIndex = 0;
      this.noMore = false;
      this.items = [];
      this.fetchData();
    }
  }

  appendData(): void {
    if (this.showSearch && !this.noMore) {
      this.pageIndex++;
      this.fetchData();
    }
  }

  private fetchData(): void {
    this.loading = true;
    const queryParameter = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      includes: this.includes || [],
      filterGroup: {
        type: 'and',
        filters: [
          {
            field: this.searchField,
            compareType: 'like',
            value: '%' + this.searchValue + '%'
          }
        ]
      }
    };
    this.http.post(this.url, queryParameter)
      .subscribe((resp: any) => {
          if (resp.content.length === 0) {
            this.noMore = true;
          }
          resp.content.forEach(data => {
            this.items.push({
              value: GnObjectUtils.getValue(data, this.valueField),
              label: GnObjectUtils.getValue(data, this.labelField)
            });
          });
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.messageService.error('获取数据错误');
          throw error;
        });
  }

  valueChange = (value: any) => {
  }

  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

}
